export class DatarouterError extends Error {
  isAppLayerMessage: boolean;
  errorDetails?: unknown;
  responseStatus?: number;

  constructor(message: string, errorDetails?: unknown) {
    super();
    this.name = 'DatarouterError';
    this.isAppLayerMessage = true;
    // This error is safe to display to front end
    this.message = message;
    this.errorDetails = errorDetails;
  }

  static isAppLayerError(error: unknown): error is DatarouterError {
    return error instanceof DatarouterError;
  }

  static getDisplayMessage(error: unknown, fallback = 'An error has occurred, please try again later'): string {
    return DatarouterError.isAppLayerError(error) ? error.message : fallback;
  }
}
